import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import "./i18nextInit";

ReactDOM.render(
  <App />,
  document.getElementById('root')
);
